import { Router, Event as RouterEvent, NavigationEnd } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from './../services/local-storage.service';

@Component({
  selector: 'app-main',
  templateUrl: './panel.component.html',
})
export class PanelComponent implements OnInit {

  public selectedCompany: boolean = false;

  constructor(
        private localStorageService: LocalStorageService

  ) {}
  ngOnInit() {
    this.selectedCompany = this.localStorageService.get('company') !== null
  }
}



// WEBPACK FOOTER //
// ./src/app/panel/panel.component.ts